import React from 'react';
import { Link } from 'react-router-dom';
import { useStoreConfigContext } from '/src/providers';
import { Thumbnail } from '/src/components';
import * as styles from './styles.scss';

const Recipe = ({
    recipe: {
        title,
        url_key,
        short_description,
        thumbnail: {
            url,
            alt,
        } = {},
        servings_number,
        cook_time,
        prep_time,
        options = []
    } = {},
}) => {
    const { translate } = useStoreConfigContext();
    const RecipeLinkWrapper = url_key ? Link : 'div';

    return (
        <div className={styles.recipe}>
            {
                !!options?.length &&
                <div className={styles.options}>
                    {
                        options.map(({ values }) => (
                            values.map(({ id, img_url, label }) => (
                                img_url &&
                                <img
                                    key={id}
                                    src={img_url}
                                    alt={label}
                                />
                            ))
                        ))
                    }
                </div>
            }
            <RecipeLinkWrapper
                { ...(url_key ? { to:`/recipes/${url_key}` } : {}) }
            >
                <Thumbnail.Recipe>
                    {url && <img src={`${url}?d=341x236`} alt={alt}/>}
                </Thumbnail.Recipe>
            </RecipeLinkWrapper>
            <Link
                className={styles.title}
                to={`/recipes/${url_key}`}
            >
                {title}
            </Link>
            <div
                className={styles.description}
                dangerouslySetInnerHTML={{ __html: short_description }}
            />
            {
                cook_time?.map(({ data, img_url, img_title }, index) => (
                    <div
                        key={index}
                        className={styles.details}
                    >
                        <div className={styles.person}>
                            <img src={img_url} alt={img_title} />
                            <div className={styles.cooking}>
                                {translate('Cooking time')}
                            </div>
                        </div>
                        <div className={styles.info}>
                            {data}
                        </div>
                    </div>
                ))
            }
            {
                servings_number?.map(({ data, img_url, img_title }, index) => (
                    <div
                        key={index}
                        className={styles.details}
                    >
                        <div className={styles.person}>
                            <img src={img_url} alt={img_title} />
                            <div className={styles.cooking}>
                                {translate('Persons')}
                            </div>
                        </div>
                        <div className={styles.info}>
                            {data}
                        </div>
                    </div>
                ))
            }
            {
                prep_time?.map(({ data, img_url, img_title }, index) => (
                    <div
                        key={index}
                        className={styles.details}
                    >
                        <div className={styles.person}>
                            <img src={img_url} alt={img_title} />
                            <div className={styles.cooking}>
                                {translate('Preparation time')}
                            </div>
                        </div>
                        <div className={styles.info}>
                            {data}
                        </div>
                    </div>
                ))
            }
            <Link
                to={`/recipes/${url_key}`}
                className={styles.link}
            >
                {translate('Read more')}
            </Link>
        </div>
    )
};

const RecipesWrapper = ({ children }) => (
    <div className={styles.wrapper}>
        {children}
    </div>
);

export { default as recipeGraphQLQueries } from './graph-ql-queries';
export {
    RecipesWrapper,
};

export default Recipe;
